import React from 'react';
import { reduxForm, Field, getFormValues, isDirty } from 'redux-form';
import { connect } from 'react-redux';
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet';
import DropdownCalendarOld from 'components/Fields/ReduxForm/DropdownCalendarOld';
import { ActionBarWrapper } from 'components/wrappers/pages';
import { MenuItem } from 'react-bootstrap';
import Dropdown from 'components/Dropdown';
import DropdownButtonSelectIcon from 'components/Fields/ReduxForm/DropdownButtonSelectIcon';
import {
  onChangeOutletIds,
  onChangeDate,
  exportAdjustment,
  onClickCreateAdjustment,
  onChangeNamespace,
  exportIngredientAdjustment,
  onSuccessImport,
  showImportModal,
  hideImportModal,
} from 'actions/inventory/adjustment';
import moment from 'moment';
import * as actNotif from 'actions/notifications';
import { askConfirmAction } from 'actions/confirm-action';
import ImportModal from 'components/ImportModal';
import {
  V1_IMPORT_ADJUSTMENTS,
  V1_IMPORT_ADJUSTMENT_TEMPLATE,
} from 'api/inventory/adjustment/constants';
import {
  V1_IMPORT_ADJUSTMENT_TEMPLATE as V1_INGREDIENT_IMPORT_ADJUSTMENT_TEMPLATE,
  V1_IMPORT_ADJUSTMENTS as V1_INGREDIENT_IMPORT_ADJUSTMENT,
} from 'api/ingredientInventory/adjustment/constants';
import * as clevertapInventoryAdjustment from 'clevertap/inventory/adjustment';
import MenuTitle from 'components/MenuTitle';
import { isFullSiteMode } from 'utils/fullSite';
import {
  ITEMS_ADJUSTMENT,
  INGREDIENTS_ADJUSTMENT,
} from 'utils/uploadS3Constants';

class ActionBar extends React.Component {
  static NAMESPACE_OPTIONS = [
    {
      id: 'items',
      name: 'Item Library',
    },
    {
      id: 'ingredients',
      name: 'Ingredients',
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      showImportModal: false,
    };
  }

  render() {
    const { outlets, isDirtyForm, isIngredientActive, search } = this.props;

    return (
      <div>
        <MenuTitle menuTitle="Adjustment" />
        <div
          className="col-sm-4 hidden-xs col-md-6 action-adjustment"
          style={{ paddingRight: 0 }}
        >
          <span className="pull-right">
            {!isFullSiteMode() && (
              <Dropdown>
                <Dropdown.Toggle
                  title="Import / Export"
                  bsStyle="primary"
                ></Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem onSelect={this._onClickImport}>
                    Import Adjustment
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem onSelect={this._onClickExport}>
                    Export Adjustment
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            )}
            <button
              className="btn btn-primary ml-10px"
              onClick={this._onClickCreateAdjustment}
            >
              Create Adjustment
            </button>
          </span>
        </div>
        <ActionBarWrapper>
          <div className="col-sm-12 col-xs-12" style={{ paddingLeft: 0 }}>
            <form className="form-inline">
              <div className="form-group mr-5px">
                <Field
                  name="outletIds"
                  component={DropdownOutlet}
                  outlets={outlets}
                  onChangeOutletIds={this._onChangeOutletIds}
                  allOutletOption
                />
              </div>
              <div className="form-group mr-5px">
                <Field
                  component={DropdownCalendarOld}
                  name="date"
                  isDirtyForm={isDirtyForm}
                  onDirtyFormCallback={this._onChangeDate}
                  onChange={this._onChangeDate}
                  updateServerOnChange
                />
              </div>
              <div className="form-group mr-5px">
                <Field
                  component={DropdownButtonSelectIcon}
                  name="namespace"
                  options={ActionBar.NAMESPACE_OPTIONS}
                  onChange={this._onChangeNamespace}
                  isDirtyForm={isDirtyForm}
                  onDirtyFormCallback={this._onChangeNamespace}
                  disabled={!isIngredientActive}
                />
              </div>
            </form>
          </div>
          {this._namespace() === 'items' && (
            <ImportModal
              dispatch={this.props.dispatch}
              pathImporting="outlet"
              templateImportUrl={V1_IMPORT_ADJUSTMENT_TEMPLATE}
              temporaryImportUrl={`${V1_IMPORT_ADJUSTMENTS}`}
              importUrl={`${V1_IMPORT_ADJUSTMENTS}?modify=true`}
              namespace="adjustment"
              selectedOutletIds={search ? search.outletIds : []}
              onCancel={() => {
                this.props.dispatch(hideImportModal());
              }}
              show={this.props.showImportModal}
              afterSuccessCallback={this._importAfterSuccessCallback}
              onErrorCallback={this._importOnErrorCallback}
              templatePrefix="Inventory Adjustment Template - "
              filterNamespace="items"
              csvHeaders={[
                'Internal ID (DO NOT EDIT)',
                'Outlet Name (DO NOT EDIT)',
                'Item Name (DO NOT EDIT)',
                'Variant Name (DO NOT EDIT)',
                'SKU (DO NOT EDIT)',
                'In Stock (DO NOT EDIT)',
                'Actual Stock',
                'Note',
              ]}
              usingSpringImport="true"
              importNamespace={ITEMS_ADJUSTMENT}
            />
          )}
          {this._namespace() === 'ingredients' && (
            <ImportModal
              dispatch={this.props.dispatch}
              pathImporting="outlet"
              templateImportUrl={V1_INGREDIENT_IMPORT_ADJUSTMENT_TEMPLATE}
              temporaryImportUrl={`${V1_INGREDIENT_IMPORT_ADJUSTMENT}`}
              importUrl={`${V1_INGREDIENT_IMPORT_ADJUSTMENT}?modify=true`}
              namespace="adjustment"
              selectedOutletIds={search ? search.outletIds : []}
              onCancel={() => {
                this.props.dispatch(hideImportModal());
              }}
              show={this.props.showImportModal}
              afterSuccessCallback={this._importAfterSuccessCallback}
              onErrorCallback={this._importOnErrorCallback}
              templatePrefix="Ingredient Inventory Adjustment Template - "
              filterNamespace="ingredients"
              csvHeaders={[
                'Internal ID (DO NOT EDIT)',
                'Outlet Name (DO NOT EDIT)',
                'Ingredient Name (DO NOT EDIT)',
                'In Stock (DO NOT EDIT)',
                'Actual Stock',
                'Unit (DO NOT EDIT)',
                'Note',
              ]}
              usingSpringImport="true"
              importNamespace={INGREDIENTS_ADJUSTMENT}
            />
          )}
        </ActionBarWrapper>
      </div>
    );
  }

  _importAfterSuccessCallback = () => {
    this.props.dispatch(onSuccessImport());
    const {
      search: { namespace },
    } = this.props;
    clevertapInventoryAdjustment.inventoryAdjustmentImport({ namespace });
  };

  _importOnErrorCallback = (errors, errorCode) => {
    const {
      search: { outletIds },
    } = this.props;

    if (parseInt(errorCode / 100) === 5) {
      this.props.dispatch(hideImportModal());
    }
    this.props.dispatch(actNotif.error(errors[0]));
    clevertapInventoryAdjustment.inventoryAdjustmentImportFailed({
      outletId: outletIds,
    });
  };

  _onClickImport = () => {
    this.props.dispatch(showImportModal());
  };

  _onClickExport = () => {
    const {
      dispatch,
      search: {
        date: { startDate, endDate },
        namespace,
        outletIds,
      },
    } = this.props;
    const dateLabel = startDate.isSame(endDate, 'days')
      ? moment(startDate).format('DD-MM-YYYY')
      : [
          moment(startDate).format('DD-MM-YYYY'),
          moment(endDate).format('DD-MM-YYYY'),
        ].join(' - ');
    let filename = '';
    clevertapInventoryAdjustment.inventoryAdjustmentExport({
      outletIds,
      startDate,
      endDate,
      namespace,
    });
    if (namespace === 'items') {
      filename = `Inventory Adjustment - ${dateLabel}`;
      dispatch(
        exportAdjustment(
          {
            start: startDate.format('D/M/YYYY'),
            end: endDate.format('D/M/YYYY'),
          },
          filename,
          outletIds[0]
        )
      );
    } else {
      filename = `Ingredient Inventory Adjustment - ${dateLabel}`;
      dispatch(
        exportIngredientAdjustment(
          {
            start: startDate.format('D/M/YYYY'),
            end: endDate.format('D/M/YYYY'),
          },
          filename,
          outletIds[0]
        )
      );
    }
  };

  _onClickCreateAdjustment = () => {
    const { dispatch, search, isDirtyForm } = this.props;
    const { outletIds } = search;
    if (isDirtyForm) {
      dispatch(askConfirmAction(onClickCreateAdjustment(outletIds[0])));
    } else {
      dispatch(onClickCreateAdjustment(outletIds[0]));
    }
  };

  _onChangeKeyword = () => {};

  _namespace = () => {
    const { search } = this.props;
    if (search) {
      return search.namespace;
    }
    return '';
  };

  /**
   * Redux form auto convert array to objects, so we change it back to array
   * @private
   * @param outletIds
   */
  _onChangeOutletIds = outletIds => {
    const {
      search: {
        date: { startDate, endDate },
        namespace,
      },
      dispatch,
      isDirtyForm,
    } = this.props;
    if (isDirtyForm) {
      dispatch(
        askConfirmAction(
          onChangeOutletIds(outletIds, startDate, endDate, namespace)
        )
      );
    } else {
      dispatch(onChangeOutletIds(outletIds, startDate, endDate, namespace));
    }
  };

  _onChangeDate = ({ startDate, endDate }) => {
    const {
      dispatch,
      isDirtyForm,
      search: { namespace, outletIds },
    } = this.props;
    if (isDirtyForm) {
      dispatch(
        askConfirmAction(onChangeDate(startDate, endDate, namespace, outletIds))
      );
    } else {
      dispatch(onChangeDate(startDate, endDate, namespace, outletIds));
    }
  };

  _onChangeNamespace = (event, namespace) => {
    // previousNamespace is reserved for clevertap tracking
    const {
      dispatch,
      isDirtyForm,
      search: {
        date: { startDate, endDate },
        outletIds,
      },
      keyword,
    } = this.props;
    const params = {
      page: 1,
      start: startDate.format('D/M/Y'),
      end: endDate.format('D/M/Y'),
      keyword,
    };
    if (isDirtyForm) {
      dispatch(
        askConfirmAction(
          onChangeNamespace(namespace, params, outletIds, startDate, endDate)
        )
      );
    } else {
      dispatch(
        onChangeNamespace(namespace, params, outletIds, startDate, endDate)
      );
    }
  };
}

const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  const {
    outlets,
    showImportModal,
    isExportLoading,
  } = state.inventory.adjustment;
  const {
    subscriptionStatus: { is_active },
  } = state.inventory.ingredientSubscription;
  return {
    outlets,
    search: getFormValues('search')(state),
    isDirtyForm: isDirty('adjustment')(state),
    showImportModal,
    isExportLoading,
    isIngredientActive: is_active,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(ActionBar));
